//  判斷是否要顯示 入會 與 推進
export const FaEnum = ['1','305'];
